// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__zWgjr","imageUploader":"EGiftCard_imageUploader__2HgRw"};